import { cn } from "@newxsystems/shared";
import type { IBackgroundContainerBlockProps } from "./BackgroundContainerBlock.props";

const defaultBackground = "machine-black";

const backgroundClassNames = {
  "deep-red": "bg-primary-900",
  "heat-field": "toot-background-heat",
  "machine-black": "bg-toot-black",
  "machine-grid": "toot-background-machine-grid",
  "machine-surface": "bg-toot-surface",
  "radar-field": "toot-background-radar",
  "raised-surface": "bg-toot-surface-raised",
  "terminal-grid": "toot-background-terminal-grid",
} as const;

const getBackgroundClassName = (background?: string) =>
  background
    ? backgroundClassNames[background as keyof typeof backgroundClassNames]
    : backgroundClassNames[defaultBackground];

export const BackgroundContainerBlock = ({
  background,
  components,
  parentClass,
}: IBackgroundContainerBlockProps) => {
  if (!components) {
    return null;
  }

  return (
    <div
      className={cn(
        "toot-background-scope text-foreground",
        getBackgroundClassName(background),
        parentClass,
      )}
      data-background={background || defaultBackground}
      data-background-container=""
    >
      {components}
    </div>
  );
};

BackgroundContainerBlock.displayName = "Block::BackgroundContainerBlock";
